// Add data attributes to created rows on a table
// Add attributes based on passed data, if data available

export default function(row, data) {

  // Core record attributes required for multiple functions
  if (typeof data.action_links !== 'undefined') { $(row).attr("data-action-links", data.action_links); }
  if (typeof data.name !== 'undefined') { $(row).attr("data-record-name", data.name); }
  if (typeof data.record_type !== 'undefined') { $(row).attr("data-record-type", data.record_type); }
  if (typeof data.token !== 'undefined') { $(row).attr("data-record-token", data.token); }
  if (typeof data.profile_type !== 'undefined') { $(row).attr("data-profile-type", data.profile_type); }
  if (typeof data.profile_id !== 'undefined') { $(row).attr("data-profile-id", data.profile_id); }
  if (typeof data.read !== 'undefined') { $(row).attr("data-read", data.read); }
  if (typeof data.account_url !== 'undefined') { $(row).attr("data-account-url", data.account_url); }
  if (typeof data.issuer_id !== 'undefined') { $(row).attr("data-issuer-id", data.issuer_id); }

  if ((typeof data.record_id !== 'undefined') && ( !$('.table').hasClass('no-click') ) ) { 
    if (data.record_id === null) {
      $(row).addClass('no-click');
    } else {
      $(row).attr("data-record-id", data.record_id); 
    }
  } else {
    $(row).addClass('no-click');
  }

  // Methodology-related attributes used in navigation
  if (typeof data.methodology_id !== 'undefined') { $(row).attr("data-methodology-id", data.methodology_id); }
  if (typeof data.framework_id !== 'undefined') { $(row).attr("data-framework-id", data.framework_id); }
  if (typeof data.slug !== 'undefined') { $(row).attr("data-slug", data.slug); }

};